module.exports = __webpack_public_path__ + "fonts/iconfont.25e3745.woff";